import { type MCPServerInfo } from '../../types';

const ClojureServer: MCPServerInfo = {
  serverId: 'CLOJURE',
  name: 'Clojure',
  slug: 'clojure',
  description:
    'Clojure MCP server. Runs locally to inspect projects, evaluate code, and apply edits.',
  source: {
    sourceType: 'LOCAL_PACKAGE',
    transport: 'STDIO',
    commandFunction: `() => {
      return {
        command: 'clojure',
        args: ['-Tmcp', 'start', ':not-cwd', 'true', ':port', '7888'],
        env: {}
      };
    }`
  },
  authenticationType: 'NONE',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  },
  deprecated: true
};

export default ClojureServer;
